"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SquareFeetOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M8,13.5859V23h9.4141Zm2,4.8282L12.5856,21H10Z"/><path d="M29.39,25.56,5.39,3.54a1.9767,1.9767,0,0,0-1.38-.56H4a2.0049,2.0049,0,0,0-2,2V28a1.0029,1.0029,0,0,0,1,1H28a1.9917,1.9917,0,0,0,2-2A1.9163,1.9163,0,0,0,29.39,25.56ZM23,27V26a1,1,0,0,0-2,0v1H18V26a1,1,0,0,0-2,0v1H13V26a1,1,0,0,0-2,0v1H8V26a1,1,0,0,0-2,0v1H4L4.01,5,28,27Z"/>';
var SquareFeetOutlineSVG = function SquareFeetOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SquareFeetOutlineSVG = SquareFeetOutlineSVG;
SquareFeetOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SquareFeetOutlineSVG);
exports.default = _default;